import { useCallback } from "react";

import { useProductOptionI18nFormModelContext } from "../../../../../context";

export const useSubOptions = () => {
	const { onSetViewModel, viewModel } = useProductOptionI18nFormModelContext();
	const { subOptions } = viewModel;

	const isEdited = subOptions?.isEdited ?? false;
	const hasError = subOptions?.hasError ?? false;

	const onSetSubOptionName = useCallback(
		(name: string, index: number) => {
			const subOptions = viewModel.subOptions;
			const newSubOptions = subOptions?.value?.map((subOption, i) => {
				if (i === index) {
					return {
						...subOption,
						name: {
							isEdited: true,
							value: name,
						},
					};
				}
				return subOption;
			});

			onSetViewModel([
				{
					key: "subOptions",
					value: {
						isEdited: true,
						hasError: false,
						value: newSubOptions,
					},
				},
			]);
		},
		[onSetViewModel, viewModel.subOptions],
	);

	return {
		isEdited,
		hasError,

		subOptions,

		onSetSubOptionName,
	};
};
